import { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { database } from "../services/firebase";

export type InscricaoType = {
    authorId: string;
    alunoFDV: boolean;
    nome: string;
    email: string;
    telefone: string;
    escolaridade: string;
    respondidoEm: string;
    removidoPor: string;
};

export type EventoType = {
    id: string;
    nome: string;
    titulo: string;
    data: string;
    auditorio: string;
    capacidade: string;
    dataAberturaInscricao: string;
    dataFechamentoInscricao: string;
    inscricoes: InscricaoType[];
    alunos: InscricaoType[];
};

export type Aluno = {
    authorId: string;
    cpf: string;
    id: string;
    nome: string;
};

export function useEventos(restrict?: boolean): EventoType[] {
    const { user } = useAuth();
    const [eventos, setEventos] = useState<EventoType[]>([]);

    useEffect(() => {
        if (user === undefined) {
            return;
        }

        const eventosRef = database.ref("eventos");

        eventosRef.orderByChild("nome").once("value", (snapshot) => {
            let parsedValues: EventoType[] = [];

            snapshot.forEach((instance) => {
                console.log("snapshot eventos");
                let evento: EventoType = instance.val();
                evento.id = instance.key || "";
                if (evento.inscricoes) {
                    let qtdInscricoes = Object.values(evento.inscricoes || {}).length;
                }
                if (user) {
                    let participa = Object.values(evento.inscricoes ?? {}).some((resposta) => resposta.authorId === user?.id);
                    Object.values(evento.inscricoes || {}).every((resposta) => {
                        if (!evento.alunos) {
                            evento.alunos = [];
                        }
                        evento.alunos.push(resposta);
                        return "";
                    });
                    if (participa && restrict) parsedValues.push(evento);
                }
                if (!restrict) {
                    parsedValues.push(evento);
                }
            });
            setEventos(parsedValues);
        });
    }, [user?.id]);

    return eventos;
}
